import {
  Box,
  HStack,
  Image,
  Text,
  Flex,
  VStack,
  Spacer,
} from "@chakra-ui/react";
import subject_icons from "../../../utils/subject-icons";
import { useMemo } from "react";
import { MobileTaskCardStyles } from "./MobileTaskCardStyles";
import {
  catagoryNames,
  getBottomIcon,
  getCreatedDate,
  getFormattedDate,
  LoadBottomText,
  subjectIconsMobile,
} from "../../../pages/task/TaskScreenHelper";

const MobileTaskCard = ({ cardData, onClick = () => null }) => {
  const {
    id,
    category,
    title,
    finishedDate,
    borderColor,
    backgroundColor,
    titleColor,
    completedOn,
    dueDate,
    subTopicName,
    topicName,
    reminder,
    levelUpNudge,
    appreciation,
    isChapterEndAssessment,
    proficientLevel,
    experientialLearning,
    levelUpReference,
    autoLevelUp,
    subjectName,
    isCustomAssessment,
    selectedOption,
    customAssessmentSubtopic,
    assignedDate,
  } = cardData;

  let customSubtopicTaskNumber = customAssessmentSubtopic?.taskNumber || 1;
  let customSubtopicNames =
    customAssessmentSubtopic?.taskAttributes?.subtopicList
      ?.map((subtopic) => subtopic?.name)
      ?.filter((name) => name)
      ?.join(", ");

  const formattedDate = useMemo(
    () => getFormattedDate(completedOn, dueDate),
    [completedOn, dueDate]
  );

  let createdDate = getCreatedDate(assignedDate);
  return (
    <Box sx={MobileTaskCardStyles()?.mainContainer} onClick={onClick}>
      <HStack sx={MobileTaskCardStyles()?.topContainer}>
        <VStack sx={MobileTaskCardStyles()?.detailsContainer}>
          <Flex sx={MobileTaskCardStyles()?.topLine}>
            <HStack sx={MobileTaskCardStyles()?.completionContainer}>
              <Text sx={MobileTaskCardStyles()?.completionText}>
                {finishedDate === "completed" ? `Completed on:` : `Finish by:`}
              </Text>
              {/* <Image
                h={"14px"}
                w={"16px"}
                src={
                  finishedDate === "completed"
                    ? accordion_images.tickCircle
                    : accordion_images.roundArrow
                }
              /> */}

              <Text
                sx={
                  selectedOption?.value === "missed_opportunity"
                    ? MobileTaskCardStyles()?.overDueDate
                    : MobileTaskCardStyles()?.inTimeDate
                }
              >
                {formattedDate}
              </Text>
            </HStack>
            <Spacer />
            {catagoryNames(category) === "Guided Practice" && (
              <Image
                sx={MobileTaskCardStyles()?.gpIcon}
                src={subject_icons.gpMobile}
              />
            )}
            <Image
              sx={MobileTaskCardStyles()?.subjectIcon}
              src={subjectIconsMobile(subjectName)}
            />
          </Flex>
          <Text sx={MobileTaskCardStyles()?.taskTitle}>
            {isCustomAssessment
              ? `Assessment Practice - ${topicName}`
              : subTopicName
              ? subTopicName
              : topicName
              ? topicName
              : ""}
          </Text>
        </VStack>
      </HStack>
      <HStack sx={MobileTaskCardStyles()?.bottomContainer}>
        {getBottomIcon(
          finishedDate,
          appreciation,
          experientialLearning,
          levelUpNudge,
          levelUpReference,
          autoLevelUp,
          isCustomAssessment,
          isChapterEndAssessment,
          proficientLevel,
          reminder,
          customSubtopicNames,
          true
        )}
        <Text sx={MobileTaskCardStyles()?.bottomText}>
          {LoadBottomText(
            false,
            levelUpNudge,
            appreciation,
            reminder,
            finishedDate,
            experientialLearning,
            levelUpReference,
            autoLevelUp,
            isCustomAssessment,
            isChapterEndAssessment,
            customSubtopicTaskNumber,
            createdDate,
            proficientLevel,
            true
          )}
        </Text>
      </HStack>
    </Box>
  );
};

export default MobileTaskCard;
